import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import 'moment/locale/ru';

moment.locale('ru');

import App from './App';

import './axiosConfig';

// MTS-DS
import '@mts-ds/base/build/styles/main.css';

import './index.css';


ReactDOM.render(<App />, document.getElementById('root'));
